import React from 'react'
import { SettingsSectionV2 } from './SettingsSectionV2'

/*
 * System → Search timeouts: the MAX_SEARCH_DURATION_* keys, in minutes. A
 * search still running when its time is up is marked failed. The backend
 * reads the key when a search starts, so a new value is used from the next
 * search; the ones already running keep the time they started with.
 */
const GROUPS = [
  { key: 'search-timeouts', title: 'Timeouts', sub: 'Each one is shared by the search types listed under it' },
]

export function SearchTimeoutsV2() {
  return (
    <SettingsSectionV2
      title="Search timeouts"
      intro="Minutes a search may run before it is marked failed. A value saved here replaces the ConfigMap one and is used from the next search."
      groups={GROUPS}
      layout="rows"
      saveNote={() => 'Used from the next search — searches already running keep their time.'}
    />
  )
}
